import React, { useRef } from 'react';
import { Box, useTheme, Button } from '@mui/material';
import { Settings } from '@mui/icons-material';
import ImportExportMAIQ, { ImportExportMAIQRef } from 'app/components/ImportExportMAIQ';
import { ImportExportTypes } from 'app/components/ImportExportMAIQ/types';

interface DealerSettingsImportExportProps {
  selectedDealerId?: string;
}

const ContentImportExport: React.FC<DealerSettingsImportExportProps> = ({ selectedDealerId }) => {
  const theme = useTheme();
  const importExportRef = useRef<ImportExportMAIQRef>(null);

  // Configure the import/export for dealer settings
  const importExportConfig = ImportExportTypes.OFFERS(selectedDealerId);

  const handleSuccess = (result: any) => {
    console.log('Import/Export successful:', result);
    // You can add additional success handling here
  };

  const handleError = (error: any) => {
    console.error('Import/Export error:', error);
    // You can add additional error handling here
  };

  const handleImportComplete = (result: any) => {
    console.log('Import completed:', result);
    // You can add specific import completion handling here
  };

  const handleExportComplete = (result: any) => {
    console.log('Export completed:', result);
    // You can add specific export completion handling here
  };

  // Custom trigger button with dealer-specific styling
  const customTriggerButton = (
    <Button
      variant="contained"
      startIcon={<Settings />}
      disabled={!selectedDealerId}
      sx={{
        backgroundColor: theme.palette.secondary.main,
        color: 'white',
        '&:hover': {
          backgroundColor: theme.palette.secondary.dark,
        },
        '&:disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          color: 'rgba(0, 0, 0, 0.26)',
        },
        textTransform: 'none',
        fontWeight: 600,
        px: 3,
        py: 1
      }}
    >
      Content Import/Export
    </Button>
  );

  return (
    <Box sx={{ p: 2 }}>
      <ImportExportMAIQ
        ref={importExportRef}
        type={importExportConfig}
        onSuccess={handleSuccess}
        onError={handleError}
        onImportComplete={handleImportComplete}
        onExportComplete={handleExportComplete}
        showImport={true}
        showExport={true}
        modalTitle="Offer Import/Export"
        triggerButton={customTriggerButton}
        disabled={!selectedDealerId}
      />
    </Box>
  );
};

export default ContentImportExport;
